import React from "react";

interface StepCardComponentProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  isHighlighted?: boolean;
}

const StepCard = ({
  icon,
  title,
  subtitle = undefined,
  isHighlighted = false,
}: StepCardComponentProps) => (
  <div
    className={`sid-id-check-step-card ${isHighlighted && "sid-id-check-step-card--highlighted"}`}
  >
    <div className="sid-id-check-step-card__icon">{icon}</div>

    <div className="sid-id-check-step-card__description">
      <div className="sid-id-check-step-card__title">{title}</div>
      {subtitle && (
        <div className="sid-id-check-step-card__subtitle sid-l-space-top-sm">{subtitle}</div>
      )}
    </div>
  </div>
);

export const StepCardComponent = StepCard;
